import { Link, useLocation } from "react-router-dom";
import { ChartNoAxesColumn, House, Mic } from "lucide-react";
import { cn } from "@/lib/utils";
import { APP_NAV } from "@/navigation";

const ICONS = {
  "/app": House,
  "/app/practice": Mic,
  "/app/progress": ChartNoAxesColumn,
} as const;

const MobileNav = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === "/app") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="safe-area-bottom fixed bottom-0 left-0 right-0 z-50 border-t border-neutral-200 bg-white md:hidden">
      <div className="flex h-14 items-center justify-around">
        {APP_NAV.map((item) => {
          const active = isActive(item.path);
          const Icon = ICONS[item.path];
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex h-11 min-w-11 flex-1 flex-col items-center justify-center gap-1 text-caption font-semibold",
                active ? "text-blue-500" : "text-neutral-500",
              )}
            >
              <Icon className="h-6 w-6" strokeWidth={active ? 2.5 : 2} absoluteStrokeWidth />
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
